import { useNuxtApp } from "#app";
import { NoopService } from "../service/noop-service";

export const useBroadcasting = () => {
  if (import.meta.server) {
    return new NoopService();
  }

  return useNuxtApp().$broadcasting;
};
